module.exports = __webpack_public_path__ + "img/ecobank_nigeria.2ca80202.svg";